import Vue from "vue";
import Router from "vue-router";
import HomePage from "./pages/HomePage.vue";
import Spolecnost from "./pages/Spolecnost.vue";
import Sluzby from "./pages/Sluzby.vue";
import Iso from "./pages/Iso.vue";
import Odpady from "./pages/Odpady.vue";
import Kontakty from "./pages/Kontakty.vue";
import Stahnout from "./pages/Stahnout.vue";
import Objednavka from "./pages/Objednavka.vue";

import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";

Vue.use(Router);

const router = new Router({
    routes: [{
            path: "/",
            name: "home",
            components: { default: HomePage, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/spolecnost",
            name: "spolecnost",
            components: { default: Spolecnost, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/sluzby",
            name: "sluzby",
            components: { default: Sluzby, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/iso",
            name: "iso",
            components: { default: Iso, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/odpady",
            name: "odpady",
            components: { default: Odpady, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/kontakty",
            name: "kontakty",
            components: { default: Kontakty, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/stahnout",
            name: "stahnout",
            components: { default: Stahnout, header: MainNavbar, footer: MainFooter },
            props: {

            }
        },
        {
            path: "/objednat",
            name: "objednat",
            components: { default: Objednavka, header: MainNavbar, footer: MainFooter },
            props: {

            }
        }
    ],

});

export default router;